module.exports = __webpack_public_path__ + "static/media/user_secured.0ae7db66.svg";